import dayjs, { Dayjs } from "dayjs";
import { useNavigate } from "react-router-dom";

import { useAnniversaryDateEvents } from "../../shared/hooks/use-date-anniversary-events";
import { useSelectedDate } from "../../shared/hooks/use-selected-date";
import {
  StyledButton,
  StyledDateEvents,
  StyledContent,
  StyledContentElem,
  StyledHeader,
} from "./date-events.style";
import { Event } from "../../shared/types/event-type";

const monthsGenitive = [
  "Студзеня",
  "Лютага",
  "Сакавіка",
  "Красавіка",
  "Мая",
  "Чэрвеня",
  "Ліпеня",
  "Жніўня",
  "Верасня",
  "Кастрычніка",
  "Лістапада",
  "Снежня",
];

const DateEvents = () => {
  const navigate = useNavigate();

  const selectedDate: Dayjs = useSelectedDate();

  const dateEventsArray: Event[] = useAnniversaryDateEvents(selectedDate);

  const selectedDateInGenetive = `${selectedDate.date()} ${monthsGenitive[selectedDate.month()]
    } ${selectedDate.year()}`;

  const onElemClick = (id: Event["id"]) => {
    navigate(`/description/${id}?date=${JSON.stringify(selectedDate)}`);
  };

  return (
      <StyledDateEvents>
        <StyledHeader>{selectedDateInGenetive}</StyledHeader>
        <StyledContent>
          {dateEventsArray.map(({ id, text, date, writerIds, placesIds }) => {
            const contentElemText: string =
              `${selectedDate.year() - dayjs(date).year()} ` + text;

            const isThereWritersOrPlaces =
              writerIds.length > 0 || placesIds.length > 0;

            // if (isThereWritersOrPlaces) {
            //   return (
            //     <StyledContentElem
            //       key={id}
            //       onClick={() => onElemClick(id)}
            //       isCursorPointer={true}
            //     >
            //       {contentElemText}
            //     </StyledContentElem>
            //   );
            // }

            return (
              <StyledContentElem key={id} isCursorPointer={false}>
                {contentElemText}
              </StyledContentElem>
            );
          })}
        </StyledContent>
        <StyledButton
          onClick={() =>
            navigate(
              selectedDate ? `/?date=${JSON.stringify(selectedDate)}` : "/",
              {
                replace: true,
              }
            )
          }
        >
          &#8592; Назад
        </StyledButton>
      </StyledDateEvents >
  );
};

export default DateEvents;
